export default __webpack_public_path__ + "static/media/AVM.1144aa3f.jpg";